/**
 * Is this token failure a session that can no longer be renewed?
 *
 * The one answer for every caller of `getTokenSilently` that has to decide
 * between "send the user back to Auth0" and "treat it as a passing glitch".
 * App.tsx's permissions effect and TenantBootstrap ask it on the same boot, so
 * they must not disagree.
 *
 * `invalid_grant` is the case that was missing: with rotating refresh tokens
 * and the iframe fallback off (ADR-0023), an expired, revoked or reused
 * refresh token comes back from Auth0's token endpoint as `invalid_grant`, not
 * `login_required`. Read as transient, it left the app on an empty grant and
 * TenantBootstrap on an endless spinner — while the Auth0 SDK still reported
 * the user as signed in from the ID token cached in localStorage. Clearing the
 * browser data was the only way out, because that deletes the dead token.
 */
const DEAD_SESSION_ERRORS = new Set([
    'login_required',
    'consent_required',
    'missing_refresh_token',
    'invalid_grant',
]);

export const isDeadSessionError = (err: unknown): boolean => {
    const code = (err as { error?: unknown } | null | undefined)?.error;
    return typeof code === 'string' && DEAD_SESSION_ERRORS.has(code);
};
